import { sendReactNativeMessage } from '@ifixit/utils';
import { onDomReady } from 'Shared/utils/dom-ready';

const MINIMUM_TIME_MS = 5 * 60 * 1000; // 5 minutes
const IDLE_TIME_MS = 60 * 1000; // 1 minute

onDomReady(() => {
   if (!window.ReactNativeWebView) {
      return;
   }

   const lastStep = document.querySelector<HTMLElement>('ol.steps-container li.js-step:last-child');
   if (!lastStep) {
      return;
   }

   const startTime = Date.now();
   let hasSeenLastStep = false;
   let promptSent = false;

   function checkAndPrompt() {
      if (promptSent) {
         return;
      }
      const timeSpent = Date.now() - startTime;
      if (hasSeenLastStep && timeSpent >= MINIMUM_TIME_MS) {
         sendReactNativeMessage({
            type: 'review_prompt_requested',
            trigger: 'Guide Viewed and Idled',
            idleMS: IDLE_TIME_MS,
         });
         promptSent = true;
      }
   }

   // threshold: 1 ensures the entire last step is visible
   const observer = new IntersectionObserver(
      entries => {
         entries.forEach(entry => {
            if (entry.isIntersecting) {
               hasSeenLastStep = true;
               observer.disconnect();
               checkAndPrompt();
            }
         });
      },
      { threshold: 1 }
   );
   observer.observe(lastStep);

   const intervalId = setInterval(() => {
      if (promptSent) {
         clearInterval(intervalId);
         return;
      }
      checkAndPrompt();
   }, 10_000);
});
